import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Loading from "../Pages/Loading";
import "./Popup.css";
import navigation from "../Auth/Navigation";

const requirementsMap = {
  "Exam Reshedule": [
    "Completed Exam Reschedule Form",
    "Proof of reason (e.g., medical certificate, event invitation)",
    "Student ID card copy",
    "Approval from course instructor (if required)"
  ],
  "Exam Re-attempt": [
    "Completed Exam Re-attempt Form",
    "Reason for re-attempt (with supporting documents)",
    "Student ID card copy"
  ],
  "Labratory Session Reshedule": [
    "Completed Lab Reschedule Form",
    "Proof of reason (e.g., medical certificate, event invitation)",
    "Student ID card copy"
  ],
  "Requesting Studentship Confirmation Letter": [
    "Request Form",
    "Student ID card copy"
  ],
  "Requesting Progress Report": [
    "Request Form",
    "Student ID card copy"
  ],
  "Requesting for New Student Record Book": [
    "Request Form",
    "Proof of loss/damage (if replacement)",
    "Student ID card copy (if available)"
  ],
  "Requesting for New Student ID card": [
    "Request Form",
    "Proof of loss/damage (if replacement)",
    "Student ID card copy (if available)"
  ]
};

const Popup = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const navigation = useNavigate();
  const location = useLocation();

  const requestName = sessionStorage.getItem("RequestName");

  if (!requestName) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#ef4444', fontWeight: 600 }}>
        No request selected. Please go back and select a document request.
      </div>
    );
  }

  const Hide_Popup = () => {
    setIsLoading(true);

    navigation("/Student-Home/MakeRequest");

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const requirements = requirementsMap[requestName] || ["Please check with the university office for requirements for this document."];

  return (
    <div id="Popup">
      {isLoading && <Loading />}
      <div className="container visible-area">
        <h1 className="text-center text-success mt-3">{requestName}</h1>
        <hr />

        <div id="Requirement-Details" className="text-dark mb-3">
          These are the main documents you need to submit:
        </div>

        <div className="col-md-2">
          <ol>
            {requirements.map((req, idx) => (
              <li key={idx}>{req}</li>
            ))}
          </ol>
        </div>

        <button className="btn btn-dark" onClick={Hide_Popup}>
          close
        </button>
      </div>
    </div>
  );
};

export default Popup;
